module.exports = __webpack_public_path__ + "img/farma-logo.138b8bcc.png";